// extracted by mini-css-extract-plugin
export var orderDetails = "_tq-2";
export var orderImage = "_tq-1";
export var orderMeta = "_tq-3";
export var orderSummary = "_tq-0";
export var rightArrow = "_tq-4";